import { cn } from "@/lib/utils"
import type { SiteStatus } from "@/types/site"

const COPY: Record<SiteStatus, { label: string; dot: string; title: string }> =
  {
    up: {
      label: "Live",
      dot: "bg-status-up",
      title: "Responded normally on the last check",
    },
    down: {
      label: "Down",
      dot: "bg-status-down",
      title: "Failed the last two checks in a row",
    },
    parked: {
      label: "Parked",
      dot: "bg-status-archived",
      title: "The domain now shows a parking or for-sale page",
    },
    dead: {
      label: "Gone",
      dot: "bg-status-archived",
      title: "Unreachable for 30+ days, or the domain stopped resolving",
    },
    unknown: {
      label: "Checking",
      dot: "bg-status-unknown animate-pulse",
      title: "Not checked yet",
    },
  }

export function StatusPill({
  status,
  className,
  overlay = false,
}: {
  status: SiteStatus
  className?: string
  overlay?: boolean
}) {
  const copy = COPY[status]
  return (
    <span
      title={copy.title}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-wide uppercase",
        overlay
          ? "bg-black/60 text-white backdrop-blur-sm"
          : "bg-muted text-muted-foreground",
        className,
      )}
    >
      <span className={cn("size-1.5 rounded-full", copy.dot)} />
      {copy.label}
    </span>
  )
}
